"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reducer = _interopRequireDefault(require("settings-ui-sdk/LanguageSettings/reducer"));

var _redux = require("redux");

var _default = (0, _redux.combineReducers)({
  languageSettings: _reducer.default
});

exports.default = _default;
module.exports = exports.default;